import React from "react";
import { TOKENS } from "../tokens";

const STATUS_MAP = {
  done:             { bg: TOKENS.successBg, fg: TOKENS.success,  label: "Completed" },
  pending:          { bg: TOKENS.warningBg, fg: TOKENS.warning,  label: "Pending" },
  approved:         { bg: TOKENS.successBg, fg: TOKENS.success,  label: "Approved" },
  rejected:         { bg: TOKENS.dangerBg,  fg: TOKENS.danger,   label: "Rejected" },
  late:             { bg: TOKENS.dangerBg,  fg: TOKENS.danger,   label: "Late" },
  present:          { bg: TOKENS.successBg, fg: TOKENS.success,  label: "Present" },
  absent:           { bg: TOKENS.dangerBg,  fg: TOKENS.danger,   label: "Absent" },
  "checked-out":    { bg: "#F1F5F9",       fg: "#64748B",         label: "Checked Out" },
  "pending-arrival": { bg: "#EFF6FF",        fg: "#3B82F6",        label: "Not In Yet" },
  od:               { bg: TOKENS.blueBg,    fg: TOKENS.blue,     label: "On OD" },
  arrived:          { bg: TOKENS.successBg, fg: TOKENS.success,  label: "Arrived" },
  "not-arrived":    { bg: TOKENS.dangerBg,  fg: TOKENS.danger,   label: "Not Arrived" },
  "on-time":        { bg: TOKENS.successBg, fg: TOKENS.success,  label: "On Time" },
  completed:        { bg: TOKENS.successBg, fg: TOKENS.success,  label: "Completed" },
  "od-completed":   { bg: TOKENS.successBg, fg: TOKENS.success,  label: "OD Completed" },
  "od-active":      { bg: TOKENS.blueBg,    fg: TOKENS.blue,     label: "OD Active" },
  "od-upcoming":    { bg: TOKENS.warningBg, fg: TOKENS.warning,  label: "OD Upcoming" },
  report:           { bg: `${TOKENS.gold}22`, fg: TOKENS.gold,   label: "Report Sent" },
  "daily-report":   { bg: `${TOKENS.gold}22`, fg: TOKENS.gold,   label: "Report Sent" },
  paid:             { bg: TOKENS.successBg, fg: TOKENS.success,  label: "Paid" },
  solved:           { bg: TOKENS.successBg, fg: TOKENS.success,  label: "Solved" },
  unsolved:         { bg: TOKENS.dangerBg,  fg: TOKENS.danger,   label: "Unsolved" },
};

/**
 * StatusPill – renders a coloured badge for an employee / task status.
 * Pass `checkOutTime` to append the time when status is "checked-out".
 */
export function StatusPill({ status, checkOutTime, style }) {
  const s = STATUS_MAP[status] || STATUS_MAP.pending;
  const label = (status === "checked-out" && checkOutTime)
    ? `✓ Out ${checkOutTime}`
    : s.label;
  return (
    <span style={{
      background: s.bg, color: s.fg,
      fontSize: 11, fontWeight: 700,
      padding: "4px 10px", borderRadius: 20,
      letterSpacing: 0.2, whiteSpace: "nowrap",
      ...style,
    }}>{label}</span>
  );
}
